// src/constants/columns/customerColumns.js

import { Link } from "react-router-dom";
import { FaEdit } from "react-icons/fa";

export const customerColumns = [
  { field: "name", headerName: "Name", flex: 1, minWidth: 150 },
  { field: "email", headerName: "Email", flex: 1, minWidth: 200 },
  { field: "phone", headerName: "Phone", flex: 1, minWidth: 150 },
  { field: "accountNumber", headerName: "Account Number", flex: 1, minWidth: 160 },
  {
    field: "totalAmount",
    headerName: "Total Amount",
    flex: 1,
    minWidth: 130,
    renderCell: (params) => `₹${params.value || 0}`,
  },
  { field: "address", headerName: "Address", flex: 1.2, minWidth: 200 },
  {
    field: "actions",
    headerName: "Actions",
    flex: 0.5,
    minWidth: 100,
    sortable: false,
    renderCell: (params) => (
      <Link
        // to={`/admin-dashboard/edit-customer/${params.row._id}`}
        to={`/admin-dashboard/customers/edit/${params.row._id}`}
        style={{ textDecoration: "none" }}
      >
        <FaEdit size={18} style={{ color: "#1976d2", cursor: "pointer" }} />
      </Link>
    ),
  },
];
